import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export const useUserStore = create()(
  devtools(
    (set, get) => ({
      selectedUser: null,
      isUserFormOpen: false,
      editingUser: null,
      userFormData: {
        name: '',
        email: '',
        role: 'user'
      },
      
      // Actions
      setSelectedUser: (user) => set({ selectedUser: user }, false, 'setSelectedUser'),
      
      openUserForm: () => set({ 
        isUserFormOpen: true,
        editingUser: null,
        userFormData: { name: '', email: '', role: 'user' }
      }, false, 'openUserForm'),
      
      closeUserForm: () => set({ 
        isUserFormOpen: false,
        editingUser: null,
        userFormData: { name: '', email: '', role: 'user' }
      }, false, 'closeUserForm'),
      
      setEditingUser: (user) => set({ 
        editingUser: user,
        isUserFormOpen: true,
        userFormData: {
          name: user.name,
          email: user.email,
          role: user.role
        }
      }, false, 'setEditingUser'),
      
      updateUserFormData: (data) => set((state) => ({ 
        userFormData: { ...state.userFormData, ...data }
      }), false, 'updateUserFormData'),
      
      resetUserForm: () => set({ 
        userFormData: { name: '', email: '', role: 'user' },
        editingUser: null
      }, false, 'resetUserForm')
    }),
    {
      name: 'user-store'
    }
  )
)